import React from 'react';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { toCapitalize } from '../../helpers/Utils/utils';

const CMCouponTierDetails = (props) => {
    const { item, isSlider } = props;
    const headlineBoldStyle = dt(['text-[16px]', 'leading-6', 'font-bold']);
    const conjunctionStyle = isSlider
        ? headlineBoldStyle
        : dt(['text-xsmall', 'font-normal', 'text-gray-60', 'pb-2']);

    const getConjunctionHealine = (offer) => {
        return isSlider ? (
            <div>
                {offer?.conjunction ? (
                    <span
                        className={[conjunctionStyle, dt(['pr-1'])].join(' ')}
                        data-automation-id="at-slider-coupon-conjunction"
                    >
                        {offer?.conjunction}
                    </span>
                ) : null}
                {
                    <span
                        className={[
                            headlineBoldStyle,
                            dt(['first:text-xlarge', 'first:leading-8']),
                        ].join(' ')}
                        data-automation-id="at-slider-tile-headline"
                    >
                        {offer?.headline}
                    </span>
                }
            </div>
        ) : (
            <>
                {offer?.conjunction ? (
                    <div className={conjunctionStyle} data-automation-id="at-coupon-conjunction">
                        {offer?.conjunction}
                    </div>
                ) : null}
                {
                    <div
                        className={dt([
                            'smOnly:text-2large',
                            'mdOnly:text-base',
                            'lg:text-2xlarge',
                            'smOnly:first:text-2xlarge',
                            'mdOnly:first:text-xlarge',
                            'smOnly:text-large',
                            'lg:first:text-[28px]',
                            'smOnly:leading-7',
                            'lg:first:leading-10',
                            'mdOnly:first:leading-8',
                            'smOnly:first:leading-9',
                            'font-bold',
                        ])}
                        data-automation-id="at-tile-headline"
                    >
                        {toCapitalize(offer?.headline)}
                    </div>
                }
            </>
        );
    };
    return item.offers?.map((offer) => {
        return (
            <div
                className={dt([
                    isSlider ? 'block' : 'flex',
                    isSlider ? '' : 'flex-col',
                    isSlider ? '' : 'smOnly:items-center',
                    isSlider ? '' : 'smOnly:text-center',
                    'first:pt-0',
                    isSlider ? 'pt-4' : 'pt-2',
                ])}
            >
                {getConjunctionHealine(offer)}
                <div
                    className={dt([
                        'text-base',
                        'lg:font-normal',
                        'smMd:text-small',
                        isSlider ? 'lg:text-sm' : '',
                        isSlider ? 'lg:leading-5' : '',
                        'text-gray-70',
                        isSlider ? '' : 'smOnly:pt-1',
                    ])}
                    data-automation-id="at-tile-subHeadline"
                >
                    {offer?.bodyCopy}
                </div>
            </div>
        );
    });
};

export default CMCouponTierDetails;
